import React, { useState, useEffect } from "react";

const useGetCartDetailsHook = () => {
  const [cartLength, setCartLength] = useState<number>(0);
  const [cart, setCart] = useState<any>([]);
  const [cartTotalPrice, setCartTotalprice] = useState<number>(0);


  useEffect(() => {
    let intervalId = setInterval(() => {
      const cartData = JSON.parse(localStorage.getItem("cart") as string);
      if (Array.isArray(cartData)) {
        setCart(cartData);
        setCartLength(
          cartData
            .map((cur) => cur.qty)
            .reduce((a, b) => {
              return a + b;
            }, 0)
        );

        let x: any = cartData
          .map((cur: any) => cur.priceing * cur.qty)
          .reduce((a: any, b: any) => {
            return a + b;
          }, 0);
        
        
          setCartTotalprice(x);
        
      }
    }, 1000);

    return () => {
      clearTimeout(intervalId);
    };
  }, []);
  return { cartLength, cartTotalPrice, cart };
};

export default useGetCartDetailsHook;
